/**
 * Cart Shop All Button Injection
 * Responsively injects a "Shop All" button into the cart
 */

class CartShopAllInjector {
  constructor() {
    this.injected = false;
    this.shopAllUrl = '/collections/catalog';
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.injectShopAllButton());
    } else {
      this.injectShopAllButton();
    }

    setTimeout(() => this.injectShopAllButton(), 500);
  }

  injectShopAllButton() {
    try {
      if (this.injected) return;

      const hasCornerCart = document.querySelector('.corner-widget-wrapper') ||
        document.querySelector('#corner-cowi-open-wrapper');
      const isCartPage = window.location.pathname === '/cart' || document.body.classList.contains('template-cart');

      if (!hasCornerCart && !isCartPage) return;

      const targetContainer = this.findInjectionTarget();
      if (!targetContainer) {
        return;
      }

      if (this.shopAllButtonExists()) return;

      const shopAllButton = this.createShopAllButton();
      this.injectButton(targetContainer, shopAllButton);

      this.injected = true;
    } catch (error) {
    }
  }

  findInjectionTarget() {
    const cornerSelectors = [
      '#corner-cowi-header',
      '#corner-corner-cart-item-list-empty',
      '#corner-cowi-cart-wrapper',
      '#corner-widget-page-wrapper',
      '.corner-widget-wrapper'
    ];

    for (const selector of cornerSelectors) {
      const element = document.querySelector(selector);
      if (element) return element;
    }

    const nativeSelectors = [
      '.buttons-right',
      '.account-area-column-cart-footer',
      '.account-area-column-empty-cart',
      '.account-area-column-cart-header'
    ];

    for (const selector of nativeSelectors) {
      const element = document.querySelector(selector);
      if (element) return element;
    }

    return null;
  }

  shopAllButtonExists() {
    return document.querySelector('[data-shop-all-injected]') !== null;
  }

  createShopAllButton() {
    const button = document.createElement('a');
    button.href = this.shopAllUrl;
    button.className = 'shop-all-cart-button';
    button.setAttribute('data-shop-all-injected', 'true');
    button.innerHTML = `Shop All`;
    return button;
  }

  injectButton(targetContainer, shopAllButton) {
    try {
      if (targetContainer.id === 'corner-cowi-header') {
        const closeButton = targetContainer.querySelector('#corner-cowi-close-btn');
        if (closeButton) {
          const wrapper = document.createElement('div');
          wrapper.className = 'flex items-center gap-2';
          
          closeButton.parentNode.insertBefore(wrapper, closeButton);
          wrapper.appendChild(shopAllButton);
          wrapper.appendChild(closeButton);
        } else {
          targetContainer.appendChild(shopAllButton);
        }
      } else if (targetContainer.id === 'corner-corner-cart-item-list-empty') {
        const buttonWrapper = document.createElement('div');
        buttonWrapper.className = 'mt-4 flex justify-center';
        buttonWrapper.appendChild(shopAllButton);
        targetContainer.appendChild(buttonWrapper);
      } else if (targetContainer.id && targetContainer.id.includes('corner')) {
        const buttonWrapper = document.createElement('div');
        buttonWrapper.className = 'p-3 flex justify-center';
        buttonWrapper.appendChild(shopAllButton);
        targetContainer.appendChild(buttonWrapper);
      } else if (targetContainer.classList.contains('buttons-right')) {
        targetContainer.insertBefore(shopAllButton, targetContainer.firstChild);
      } else if (targetContainer.classList.contains('account-area-column-empty-cart')) {
        const existingContent = targetContainer.innerHTML;
        targetContainer.innerHTML = `
          ${existingContent}
          <div class="empty-cart-actions">
            ${shopAllButton.outerHTML}
          </div>
        `;
      } else {
        targetContainer.appendChild(shopAllButton);
      }
    } catch (error) {
    }
  }

  handleResponsiveChanges() {
    const button = document.querySelector('[data-shop-all-injected]');
    if (!button) return;

    const isMobile = window.innerWidth <= 768;
    button.classList.toggle('shop-all-mobile', isMobile);
    button.classList.toggle('shop-all-desktop', !isMobile);
  }
}

if (!window.cartShopAllInjector) {
  window.cartShopAllInjector = new CartShopAllInjector();

  window.addEventListener('resize', () => {
    window.cartShopAllInjector.handleResponsiveChanges();
  });
}